import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    container: {
      display: "flex",
      justifyContent: "space-between",
      gap: theme.spacing(12),
      margin: theme.spacing(0, -9.5),
      padding: theme.spacing(5, 10),
      borderBottom: `1px solid ${theme.gray100}`,
    },
    buttonGroup: {
      width: "auto",
      alignItems: "flex-start",
    },
    wrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: theme.spacing(8),
      flexWrap: "nowrap",
    },
    alignRight: {
      marginLeft: "auto",
    },
    buttonGroupButton: {
      padding: theme.spacing(3, 4),
      borderTopLeftRadius: "6px",
      borderBottomLeftRadius: "6px",
      "&:hover": {
        backgroundColor: theme.primary500,
      },
    },
    hiddenArrowButton: {
      backgroundColor: "inherit !important",
      border: "none",
      boxShadow: "none !important",
      color: theme.primary500,
      marginRight: theme.spacing(-4),
      "&:hover": {
        background: "none",
      },
    },
    hiddenArrowDisabledButton: {
      backgroundColor: "inherit !important",
    },
    buttonGroupIcon: {
      padding: theme.spacing(3, 4),
      backgroundColor: theme.primary500,
      color: theme.white50,
      borderTopRightRadius: "6px",
      borderBottomRightRadius: "6px",
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderLeft: "1px solid #6F65AF",
      boxShadow:
        "0px 1px 5px 0px rgba(0, 0, 0, 0.12),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 3px 1px -2px rgba(0, 0, 0, 0.20)",
      "&:hover": {
        backgroundColor: theme.primary500,
      },
    },
    whiteButtonGroupIcon: {
      background: "none",
      border: "none",
      boxShadow: "none",
      color: theme.primary500,
      "&:hover": {
        background: "none",
      },
    },
    disabled: {
      cursor: "not-allowed",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.12)",
      },
    },
    disabledLinkButton: {
      "&:hover": {
        backgroundColor: theme.gray300,
        color: theme.gray600,
        border: "none",
      },
    },
    menu: {
      boxShadow:
        "0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 11px 0px rgba(0, 0, 0, 0.14), 0px 3px 7px -1px rgba(0, 0, 0, 0.20)",
    },
    menuItem: {
      borderRadius: "8px",
      margin: theme.spacing(0, 4),
      padding: theme.spacing(4),
    },
    icon: {
      display: "flex",
      alignItems: "center",
      "& svg": {
        width: "16px",
        height: "16px",
        color: theme.gray800,
        stroke: theme.gray800,
      },
      "& path": {
        strokeWidth: "2px",
      },
    },
    iconOnly: {
      margin: 0,
      minWidth: "auto",
      padding: theme.spacing(4.5),
      "& span": {
        margin: 0,
      },
    },
  }),
);
